// extracted by mini-css-extract-plugin
export default {"app":"dhks__app","sr-trap":"dhks__sr-trap","srTrap":"dhks__sr-trap","nrklogo":"dhks__nrklogo","buttons":"dhks__buttons","error":"dhks__error"};